<template>
  <header>
    <div class="content">
      <header-menu />
    </div>
  </header>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu'
export default {
  name: 'MainHeader',
  components: {HeaderMenu},
}
</script>

<style scoped>
header {
  background-color: var(--font-1);
}
.content {
  display: flex;
  margin: auto;
  width: 97%;
  max-width: 1240px;
}
</style>
